import React, { useState, useEffect, useRef } from 'react'; 
import { v4 as uuidv4 } from 'uuid';
import ReactMarkdown from 'react-markdown';
import styles from './widget_new_style.module.css';
import ContactForm from './ContactForm';
import defaultSettings from './settings.json';
import WhenClosed from './WhenClosed';

const GetSettings = () => {
};

async function getChatGPTResponse(prompt, promptSettings, context, history) {
  const message = `Settings: ${promptSettings}\n Website context: ${context}\n Chat history: \n${history}\n IMPORTANT: Give the user a small amount of summarized information No more than 60 Words per response, provide links where the user can read more in the response. Write very short responses.This is the end for the context this is the user message that you will respond to :{EndOfContex} \n${prompt}`;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 50000);
  try {
    const response = await fetch('https://app.enqelt.com/wp-json/enqelt-api/v1/enqeltdashboardapi/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message: message
      }),
      signal: controller.signal
    });
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();    
    if (!data.response) {
      throw new Error('Invalid response format');
    }
    
    let processedResponse = data.response;
    processedResponse = processedResponse.replace(/\n\d+\.\s+/g, '\n\n');
    processedResponse = processedResponse.replace(/\sn\/\s/g, '\n\n');
    
    return processedResponse;
  } catch (error) {
    console.error('Error in getChatGPTResponse:', error);
    if (error.name === 'AbortError') {
      return "Sorry, the request timed out. Please try again.";
    }
    return "Sorry, there seems to be a connection problem. Please try again later.";
  }
}

function WidgetComponent(props) {
  const [settings, setSettings] = useState(props.settings || defaultSettings);
  const [isOpen, setIsOpen] = useState(props.isOpen || false);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    setSettings(props.settings);
  }, [props.settings]);

  useEffect(() => {
    GetSettings(); 
  }, []);

  const [showBubble, setShowBubble] = useState(true);
  const typingGif = 'https://app.enqelt.com/wp-content/uploads/2024/09/typing_1.gif';
  const botAvatar = settings.botAvatar;
  const firstMessage = settings.firstMessage || "No first message provided";
  const closeIcon = "close"; 
  const reloadIcon = "refresh"; 
  const sendIcon = "send"; 
  const [input, setInput] = useState('');
  const color = settings.color;
  const fontSize = settings.fontSize || '14px';
  const widgetHeightMultiplier = settings.widgetHeightMultiplier || 1;
  const widgetWidthMultiplier = settings.widgetWidthMultiplier || 1;
  const widgetHeight = 545 * widgetHeightMultiplier;
  const widgetWidth = 335 * widgetWidthMultiplier;
  const [messages, setMessages] = useState([{ 
    text: firstMessage, 
    user: false,
    timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }]);
  const [sessionId, setSessionId] = useState(uuidv4());
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const [showOpenButton, setShowOpenButton] = useState(!isOpen); 
  const dropdownRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }
  const close = () => {
    setIsOpen(false);
    setShowOpenButton(true); 
    setDropdownOpen(false);
    setShowBubble(false);
  };
  const open = () => {
    setIsOpen(true);
    setShowOpenButton(false); 
  };

  const restart = () => {
    setInput('');
    setMessages([{ text: firstMessage, user: false, timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
    setIsTyping(false);
    setIsOpen(true);
    setDropdownOpen(false);
    setSessionId(uuidv4());
  };
  useEffect(() => {
    if (isTyping) {
      scrollToBottom();
    }
  }, [isTyping]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const GetResponseFromAPI = async (prompt) => {
    try {
      const history = messages.map(msg => `${msg.user ? 'User' : 'Bot'}: ${msg.text}`).join('\n');
      const response = await getChatGPTResponse(prompt, settings.promptSettings, settings.contextText, history);
      return typeof response === 'string' ? response : JSON.stringify(response);
    } catch (error) {
      return "I am facing some issues, please try again later";
    }
  };

  const onSubmit = async (formData) => {
    const formDataString = `Namn: ${formData.name}, Efternamn: ${formData.lastName}, Telefonnummer: ${formData.phoneNumber}, Epost: ${formData.email}`;
    setIsTyping(true);
    const response = await GetResponseFromAPI(formDataString);
    setIsTyping(false);
    setMessages(prevMessages => [...prevMessages, { text: response, user: false, timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
  };

  useEffect(scrollToBottom, [messages]);

  const handleSubmit = async () => {
    if (input.trim() === '') return;
    
    setMessages(prevMessages => [...prevMessages, { text: input, user: true, timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
    const userInput = input;
    setInput('');
    setIsTyping(true);
    const response = await GetResponseFromAPI(userInput);
    setIsTyping(false);
    setMessages(prevMessages => [...prevMessages, { text: response, user: false, timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
  };

  const handleKeyPress = async (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      await handleSubmit();
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);

  if (!isOpen) {
    return <WhenClosed open={open} settings={settings} bubble={showBubble}/>;
  }

  return (
      <div className={styles.widget} style={{ 
        fontSize, 
        height: `${widgetHeight}px`, 
        width: `${widgetWidth}px`, 
        display: 'flex', 
        flexDirection: 'column',
        borderRadius: '16px',
        boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.1), 0 8px 16px 0 rgba(0, 0, 0, 0.1)'
      }}>
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"></link>
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap" rel="stylesheet"></link>
        
        {/* Updated Header Design */}
        <div className={`${styles.chat_header} drag-handle`} style={{ 
          display: 'flex', 
          flexDirection: 'column',
          backgroundColor: color,
          borderRadius: '16px 16px 0 0',
          padding: '16px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
        }}>
          {/* Top section with buttons */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: '12px'
          }}>
            {/* Left side - Bot info */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
            }}>
              <img 
                src={botAvatar} 
                alt="Assistant" 
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  marginRight: '12px',
                  border: '2px solid rgba(255, 255, 255, 0.3)'
                }}
              />
              <div style={{
                display: 'flex',
                flexDirection: 'column'
              }}>
                <span style={{
                  color: 'white',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '600',
                  fontSize: '15px'
                }}>
                  AI Assistant
                </span>
                <span style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '400',
                  fontSize: '12px'
                }}>
                  Online
                </span>
              </div>
            </div>
            
            {/* Right side - Control buttons */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <button 
                onClick={restart} 
                title="Start new conversation"
                style={{ 
                  background: 'rgba(255, 255, 255, 0.15)', 
                  border: 'none', 
                  marginRight: '8px', 
                  cursor: 'pointer',
                  padding: '6px',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  transition: 'background 0.2s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'}
                onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
              >
                <i className="material-icons" style={{ color: 'white', fontSize: '18px' }}>{reloadIcon}</i>
              </button>
              <button 
                onClick={close} 
                title="Close chat"
                style={{ 
                  background: 'rgba(255, 255, 255, 0.15)', 
                  border: 'none', 
                  cursor: 'pointer',
                  padding: '6px',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  transition: 'background 0.2s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'}
                onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
              >
                <i className="material-icons" style={{ color: 'white', fontSize: '18px' }}>{closeIcon}</i>
              </button>
            </div>
          </div>  

        </div>
        
        <div className={styles.chats} id="chats" style={{ 
          flex: 1, 
          overflowY: 'auto',
          padding: '12px',
          backgroundColor: '#f5f5f7' // Light gray background for chat area
        }}>
          {messages.map((message, index) => (
            <div key={index}>
              {message.user ? (
                <div className={styles.userMsgContainer} style={{ marginBottom: '16px' }}>
                  <p className={styles.userMsg} style={{ 
                    backgroundColor: color,
                    borderRadius: '18px 4px 18px 18px',
                    padding: '12px 16px',
                    marginBottom: '4px',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Inter, sans-serif'
                  }}>{message.text}</p>
                  <div className={styles.timestampBox}>
                    <p className={styles.userTimestamp} style={{ fontSize: '10px' }}>{message.timestamp}</p>
                  </div>
                </div>
              ) : (
                <div className={styles.botMsgContainer} style={{ marginBottom: '16px' }}>
                  <img className={styles.botAvatar} src={botAvatar} alt="Bot avatar" style={{
                    marginRight: '8px',
                    width: '32px',
                    height: '32px'
                  }} />
                  <ReactMarkdown className={`${styles.botMsg} selectable-text`} 
                    components={{
                      a: ({node, ...props}) => <a style={{ color: color }} {...props} />
                    }}
                    style={{
                      borderRadius: '4px 18px 18px 18px',
                      padding: '12px 16px',
                      marginBottom: '4px',
                      backgroundColor: 'white',
                      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
                      fontFamily: 'Inter, sans-serif'
                    }}
                  >{message.text.replace('{contact_form}', '')}</ReactMarkdown>
                  <div className={styles.timestampBox}>
                    <p className={styles.botTimestamp} style={{ fontSize: '10px' }}>{message.timestamp}</p>
                  </div>
                  {message.text.includes('{contact_form}') && (
                    <div>
                      <img className={styles.botAvatar} src={botAvatar} alt="Bot avatar" />
                      <ContactForm onSubmit={onSubmit} />
                      <div className={styles.clearfix}></div>
                    </div>
                  )}
                </div>
              )}
              <div className={styles.clearfix}></div>
            </div>
          ))}
          {isTyping && (
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '4px', marginBottom: '16px' }}>
              <img className={styles.botAvatar} src={botAvatar} alt="Bot avatar" style={{
                width: '32px',
                height: '32px',
                marginRight: '8px'
              }} />
              <img src={typingGif} alt="Typing..." style={{ 
                width: '60px', 
                height: '38px', 
                marginLeft: '8px',
                padding: '4px 8px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
              }} />
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>
        
        <div style={{ 
  display: 'flex', 
  alignItems: 'center', 
  padding: '12px 16px',
  backgroundColor: 'white',
  borderTop: '1px solid #eaeaea'
}}>
  <div style={{ 
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    borderRadius: '24px',
    backgroundColor: '#f0f0f0',
    padding: '4px 4px 4px 16px',
    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.05)'
  }}>
    <input 
      type="text" 
      id="userInput" 
      placeholder="Type your message..." 
      className={`${styles.usrInput} selectable-text`} 
      value={input} 
      onChange={event => setInput(event.target.value)} 
      onKeyPress={handleKeyPress} 
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck="false"
      data-form-type="other"
      style={{ 
        fontSize,
        flex: 1,
        border: 'none',
        background: 'transparent',
        fontFamily: 'Inter, sans-serif',
        padding: '8px 0'
      }} 
    />
    <button 
      onClick={handleSubmit}
      disabled={input.trim() === ''}
      style={{
        background: color,
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        width: '36px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: input.trim() === '' ? 'default' : 'pointer',
        opacity: input.trim() === '' ? 0.6 : 1,
        transition: 'all 0.2s ease'
      }}
    >
      <i className="material-icons" style={{ fontSize: '18px' }}>{sendIcon}</i>
    </button>
  </div>
</div>
        
        <div style={{ 
          textAlign: 'center', 
          padding: '8px', 
          fontSize: '11px', 
          color: '#888', 
          fontFamily: 'Inter, sans-serif',
          borderTop: '1px solid #eaeaea',
          backgroundColor: 'white',
          borderRadius: '0 0 16px 16px'
        }}>
          Powered by <a href="https://enqelt.com" target="_blank" rel="noopener noreferrer" style={{ 
            color: color, 
            textDecoration: 'none',
            fontWeight: 500
          }}>Enqelt</a>
        </div>
      </div>
  );
}

export default WidgetComponent;